export default "__VITE_ASSET__DzvnwcdY__"